import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agency-one-work-process',
  templateUrl: './agency-one-work-process.component.html',
  styleUrls: ['./agency-one-work-process.component.scss']
})
export class AgencyOneWorkProcessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
